import { Directive, HostListener, ElementRef } from '@angular/core';
import {
  NG_VALUE_ACCESSOR, ControlValueAccessor
} from '@angular/forms';

@Directive({
  selector: '[cpfMask]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CpfMaskDirective,
    multi: true
  }]
})
export class CpfMaskDirective implements ControlValueAccessor {

  constructor(private el: ElementRef) { }

  onTouched: any;
  onChange: any;
  cpfMask = '999.999.999-99';

  writeValue(initValue: any): void {
    setTimeout(() => {
      this.el.nativeElement.value = initValue;
    }, 50);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('blur')
  onblur() {
    this.onTouched(true);
  }

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {
    let value = $event.target.value.replace(/\D/g, '');
    const pad = this.cpfMask.replace(/\D/g, '').replace(/9/g, '_');
    const valueMask = value + pad.substring(0, pad.length - value.length);

    if ($event.keyCode === 8) {
      if ($event.target.value.length !== 14) {
        this.onChange(value);
        return;
      }
    } else if ($event.keyCode === 13 || $event.keyCode === 32) {
      this.onChange(value);
      return;
    }

    if (value.length <= pad.length) {
      this.onChange(value);
    }

    let valueMaskPos = 0;
    value = '';
    for (let i = 0; i < this.cpfMask.length; i++) {
      if (isNaN(Number(this.cpfMask.charAt(i)))) {
        value += this.cpfMask.charAt(i);
      } else {
        value += valueMask[valueMaskPos++];
      }
    }

    if (value.indexOf('_') > -1) {
      value = value.substr(0, value.indexOf('_'));
    }
    this.onChange(value);
    $event.target.value = value;
    this.onTouched(true);
  }
}
